import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import { getCompany } from 'helpers/getCompanyVariables';
import CarrierResourcesOneill from 'tailwind-components/CarrierResources/CarrierResources';
import CarrierResourcesSunshine from './CarrierResources';
import { getAppointmentsViewData } from 'state/actions/actions';
import { getCarrierFaqs } from 'state/actions/faqs';

const isOneill = getCompany() === 'oneill';
const CarrierResources = isOneill
  ? CarrierResourcesOneill
  : CarrierResourcesSunshine;

const mapStateToProps = ({ appointments, user, faqs }) => ({
  user: user.zohoData,
  carriers: appointments.carriers,
  appointedCarriers: appointments.appointedCarriers,
  carrierFaqs: faqs.carrierFaqsArray,
  carrierLoader: faqs.carrierLoader
});

export default connect(mapStateToProps, {
  getAppointmentsViewData,
  getCarrierFaqs
})(
  withLocalLoader(
    CarrierResources,
    true,
    'Carrier Resources',
    'Carrier Resources'
  )
);
